<template src="./Index.html">
</template>

<script>
import { showNotification } from "../../../../../../utils/helpers";


    export default {
        created() {
            this.$store.dispatch("lookups/getLookups")
            this.$store.dispatch("lookups/getNationalities")
            console.log(this.employee.type)
        },
        model: {
            prop: "employee",
        },

        props: ["employee"],
        computed: {
            genders() {
                return this.$store.getters["lookups/getLookupByType"](this.$lookupTypes.Genders);
            },
            nationalities() {
                return this.$store.state.lookups.nationalities;
            },
          
        
            socialStatus() {
                return this.$store.getters["lookups/getLookupByType"](this.$lookupTypes.SocialStatus);
            },
         
           identificationTypes() {
    const items = this.$store.getters["lookups/getLookupByType"](
        this.$lookupTypes.IdentificationTypes
    );

    const requiredOptions = [
        { label: "الرقم الوطني", value: 10001 },
        { label: "الرقم الإداري", value: 10002 },
    ];

    return [
        ...items,
        ...requiredOptions.filter(
            option => !items.some(
                item => Number(item.value) === option.value
            )
        ),
    ];
},
            nameDisable() {
                if (this.employee.personalInformation.firstName == null
                    || this.employee.personalInformation.firstName == ""
                    || this.employee.personalInformation.fatherName == null
                    || this.employee.personalInformation.fatherName == ""
                    || this.employee.personalInformation.surname == null
                    || this.employee.personalInformation.surname == "") {
                    return true
                } else return false
            }

        },
        data() {
            return {
                dialog: false,
               
                name: {}
            }
        },
        methods: {

            confirm() {
                this.dialog = false;

            },

            nextStep() {
               this.$emit("nextStep");
            },
            allowedDates(val) {
                const today = new Date();
                today.setFullYear(today.getFullYear() - 15);
                const date = new Date(val);
                return date < today;
            },

            notFutureDates(val) {
                const today = new Date();
                const date = new Date(val);
                return date < today;
            },
            checkName() {
                let params = {
                    firstName: this.employee.personalInformation.firstName,
                    fatherName: this.employee.personalInformation.fatherName,
                    grandfatherName: this.employee.personalInformation.grandfatherName,
                    surname: this.employee.personalInformation.surname,
                   
                }

                this.$store.dispatch("employees/checkName", params).then((res) => {
                    if (res.empList != null) {
                        this.name = res.empList;

                        this.dialog = true;
                    }else showNotification("لا يوجد موظف بنفس الاسم")

                })
                    .catch(() => { });
              
              
            }

        },
    };
</script>
